import React, { useEffect, useState, useRef } from 'react';
import { View, Text, StyleSheet, Animated, TouchableOpacity, Linking, Image, ScrollView } from 'react-native';
import { Feather } from '@expo/vector-icons';
import styles from './styles/styles';  // Import the styles
import Sidebar from './sidebar';  // ✅ Import the new Sidebar
import Footer from './footer'; // ✅ Import Footer
import Header from './header'; // ✅ Import Footer


const AboutUs = ({ navigation }) => {

  const [activeLink, setActiveLink] = useState('AboutUs');

  const [showSidebar, setShowSidebar] = useState(false);

  const handleLinkPress = (screen) => {
    setShowSidebar(false); // Close sidebar on navigation
    navigation.navigate(screen);
  };

   const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };


  return (
    <View style={styles.pageContainer}>

    {/* Fixed Header */}
    <View style={styles.fixedHeader}>
       <Header onToggleSidebar={toggleSidebar} />
    </View>

      {showSidebar && (
        <Sidebar
          activeLink={activeLink}
          handleLinkPress={handleLinkPress}
          onClose={() => setShowSidebar(false)}
        />
      )}

       {/* Scrollable Content */}
    <ScrollView contentContainerStyle={styles.scrollContainer}>

      {/* Main Content */}
      <View style={styles.mainContent}>
        <Text style={styles.heading}>About Us</Text>

       {/* Plain Paragraphs */}
      <View style={styles.paragraphContainer}>
        <Text style={styles.paragraph}>
          IntegrationX delivers AI-powered integrations that help businesses move faster, work smarter, and scale effortlessly.
   
          We automate end-to-end processes, giving teams real-time control and eliminating IT bottlenecks. Powered by open-source and serverless tech, our solutions are modern, cost-effective, and built for performance.
 
          With IntegrationX, your systems work seamlessly—so your business can too.
        </Text>

      </View>
      
     <View style={{ height: 20 }} /> 
      
      <View style={styles.imageWrapper}>
        <Image
          source={require('./assets/aboutus.png')}
          style={styles.storyImage}
          resizeMode="cover"
        />
      </View>
      
       <View style={{ height: 20 }} />

       <Text style={styles.heading}>Our vision for the future of Integration</Text>

       {/* Plain Paragraphs */}
      <View style={styles.paragraphContainer}>
        <Text style={styles.paragraph}>
          Our mission is to ensure that AI-driven integration—where systems communicate, adapt, and evolve intelligently—benefits all of humanity. We believe the future lies in empowering businesses with autonomous, scalable, and resilient integration solutions that minimize human intervention while maximizing insight, efficiency, and control.
        </Text>
      </View>


        {/* Footer */}
        <Footer navigation={navigation} />

      </View>
      </ScrollView>
    </View>
  );
};

export default AboutUs;
